export default __webpack_public_path__ + "b6549269a4526e1d847397300a001bb2.png";